/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import Vue from "vue";

import { Customers } from "App";
import { GroupCompany } from "App/Contracts";

/* LE NOM DE LA SOCIETE A COTE DU NUMERO DE GROUPE ( Fred, 26/09/2026 ) — sur les
   ecrans Support clients, « Groupe 204 » ne dit rien a personne.

   Le service de l'agent ne connait que le numero de groupe ; la societe vit dans
   la table des clients de la Console ( un client = un groupe ). On la demande en
   UN appel pour tous les groupes affiches ( `Customers/ByGroups` ), et on la
   garde pour la session : un groupe deja demande ne l'est plus. A defaut de
   societe, le nom du contact. Un groupe sans client Console reste sans nom. */

const state = Vue.observable( { names: {} as { [ group: string ]: string } } );

const asked = new Set<number>();

export async function LoadCompanies( groups: ( number | string | null )[] ): Promise<void> {
    const wanted = groups
        .map( ( group ): number => Number( group ) )
        .filter( ( group: number, index: number, all: number[] ): boolean =>
            Number.isInteger( group ) && group > 0 && !asked.has( group )
            && all.indexOf( group ) === index );

    if( wanted.length === 0 )
        return;

    wanted.forEach( ( group: number ): void => {
        asked.add( group );
    } );

    const [ companies ] = await Customers.CompaniesByGroups( wanted );

    companies.forEach( ( entry: GroupCompany ): void => {
        const label = ( entry.Company || "" ).trim() !== "" ? entry.Company : entry.Name;

        if( ( label || "" ).trim() !== "" )
            Vue.set( state.names, String( entry.Group ), label.trim() );
    } );
}

export function CompanyOf( group: number | string | null ): string {
    return group === null ? "" : ( state.names[ String( group ) ] || "" );
}
